import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/output.css'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import { useCommonStore } from './store/common'

function readHomeSeed() {
  const path = window.location.pathname.replace(/\/$/, '') || '/'
  if (!['/', '/home'].includes(path)) return null
  const seed = document.getElementById('promo-state')
  if (!seed?.textContent) return null
  try { return JSON.parse(seed.textContent) } catch (e) { return null }
}

async function mountApp(state) {
  const app = createApp(App)
  const pinia = createPinia()
  app.use(pinia)
  const store = useCommonStore(pinia)
  if (state?.brands) store.$patch({ brandData: state.brands, brandsLoaded: true, displayDate: state.date || store.displayDate })
  app.use(createHead()).use(router)
  await router.isReady()
  app.mount('#app')
  if (['Home', 'couponDetail'].includes(router.currentRoute.value.name) && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: 'AW-11283985962/QEksCK76m94ZEKrsz4Qq' })
  }
}

const state = readHomeSeed()

function startWhenIdle() {
  let started = false
  const start = () => {
    if (started) return
    started = true
    cleanup()
    mountApp(state)
  }
  const startOnPointer = event => {
    if (event.target?.closest?.('a[href]')) return
    start()
  }
  const cleanup = () => {
    window.removeEventListener('pointerdown', startOnPointer)
    window.removeEventListener('keydown', start)
    window.removeEventListener('scroll', start)
    window.removeEventListener('focusin', start)
  }
  window.addEventListener('pointerdown', startOnPointer, { passive: true })
  window.addEventListener('keydown', start, { once: true })
  window.addEventListener('scroll', start, { once: true, passive: true })
  window.addEventListener('focusin', start, { once: true })
  window.setTimeout(start, 7000)
}

if (state && document.getElementById('promo-state')) {
  startWhenIdle()
} else {
  mountApp(state)
}
